import { RootState } from '../store';

export const selectPocs = (state: RootState) => state.admin.pocs;
export const selectAdminIsLoading = (state: RootState) => state.admin.isLoading;
export const selectAdminError = (state: RootState) => state.admin.error;
